import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import LazyContext from '../../../LazyLoadingImage/LazyContext';
import StandardThumb from '../../../DeviationViews/Thumb/Standard';
import { AllowedIndicators } from '../../../DeviationViews/Thumb/legos/DeviationThumbIndicators';
import AdoptableShopCard from '../../../ShopCard/AdoptableShopCard';
import Slider, { SeeAllSlide } from '@wix/da-ds/pkg/Slider';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import { ExhibitionistWidgetType, GallectionSourceType } from '../types';
import { useExhibitionistType } from '../hooks';
import s from './ExhibitionistStrip.scss';
const ExhibitionistStrip = ({ moduleId })=>{
    const { t } = useTranslation();
    const isSellerDiscountsEnabled = useFlag('seller_discounts');
    const allowedIndicators = isSellerDiscountsEnabled ? AllowedIndicators.Discount : AllowedIndicators.None;
    const exhibitionistType = useExhibitionistType();
    const currentUser = useCurrentUser();
    const shortStrip = exhibitionistType === ExhibitionistWidgetType.STRIP_SHORT;
    const { moduleData } = useModuleData(moduleId);
    const { deviations, seeAllUrl, sourceType, hasMore } = moduleData;
    const isAdoptables = sourceType === GallectionSourceType.ADOPTABLE_FOR_SALE || sourceType === GallectionSourceType.ADOPTABLE_BOUGHT;
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement(Slider, {
        className: c(s['slider'], isAdoptables && s['slider-adoptables'], shortStrip && s['slider-short']),
        scrollBy: 0.5
    }, deviations.map((deviation)=>{
        if (isAdoptables) {
            var _adoptable_owner;
            const extraProps = {};
            const adoptable = deviation.adoptable;
            const isOpenForSale = (adoptable === null || adoptable === void 0 ? void 0 : adoptable.thumbSaleState) === 'open';
            extraProps['hidePrice'] = !isOpenForSale;
            extraProps['hideSold'] = true;
            if (!isOpenForSale && (adoptable === null || adoptable === void 0 ? void 0 : (_adoptable_owner = adoptable.owner) === null || _adoptable_owner === void 0 ? void 0 : _adoptable_owner.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId)) {
                extraProps['detailsRightSlot'] = /*#__PURE__*/ React.createElement(BuyButton, {
                    isFakeButton: true,
                    size: "medium",
                    fillContainerWidth: true,
                    rounded: true
                }, t('common.sell'));
            }
            return /*#__PURE__*/ React.createElement(AdoptableShopCard, _object_spread({
                key: deviation.deviationId,
                deviation: deviation,
                width: 328,
                allowedIndicators: allowedIndicators
            }, extraProps));
        }
        return /*#__PURE__*/ React.createElement(StandardThumb, {
            key: deviation.deviationId,
            className: s['slider-item'],
            deviation: deviation,
            height: shortStrip ? 180 : 240,
            responsive: false
        });
    }), hasMore && seeAllUrl && /*#__PURE__*/ React.createElement(SeeAllSlide, {
        seeAllUrl: seeAllUrl
    })));
};
ExhibitionistStrip.displayName = 'ExhibitionistStrip';
export default ExhibitionistStrip;

//# sourceMappingURL=ExhibitionistStrip.js.map